import { groupOptions, sortOptions } from "@/shared/atoms/useMapOrdersSettings";
import { useSetModal } from "@/shared/atoms/useModal";
import useMapOrdersSettingsMutation from "@/shared/mutations/mapOrders/useMapOrdersSettingsMutation";
import useMapOrdersSettingsQuery from "@/shared/queries/mapOrders/useMapOrdersSettings";
import { couriersMapStatusses } from "@/shared/utils/constant";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BooleanWithLabel from "../Boolean/BooleanWithLabel";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";
import Select from "../Select/Select";
const MapOrdersSettingsModal = (props) => {
  const save = useMapOrdersSettingsMutation();
  const { data, refetch } = useMapOrdersSettingsQuery();
  const setModal = useSetModal();
  const { t } = useTranslation();
  const [options, setOptions] = useState(data);
  const onSave = () => {
    save.mutateAsync(options).then(() => {
      refetch();
      props.onExit();
    });
  };

  return (
    <Modal
      width={{ _: "90%", md: "50rem" }}
      onExit={() => setModal("")}
      {...props}
    >
      <div>
        <h2>{t("settings")}</h2>
        <div className="my-[2rem]">
          <Select
            menuPlacement="bottom"
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
            menuPortalTarget={document.getElementById("root")}
            getOptionLabel={(option) => `${t(option.label)}`}
            options={groupOptions}
            label={t("groupBy")}
            value={groupOptions[options.cluster_options - 1]}
            onChange={({ value }) =>
              setOptions((v) => ({ ...v, cluster_options: value }))
            }
          />
        </div>
        <div className="my-[2rem]">
          <Select
            onChange={({ value }) =>
              setOptions((v) => ({ ...v, sort_options: value }))
            }
            value={sortOptions[options.sort_options - 1]}
            menuPlacement="bottom"
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
            menuPortalTarget={document.getElementById("root")}
            getOptionLabel={(option) => `${t(option.label)}`}
            options={sortOptions}
            label={t("sortBy")}
          />
        </div>
        <div className="my-[2rem]">
          <Select
            label={t("user.deliveryMethods")}
            options={couriersMapStatusses}
            onChange={(value: any[]) =>
              setOptions((v) => ({
                ...v,
                statuses: value?.flatMap((v) => v?.value),
              }))
            }
            isMulti
            menuPlacement="bottom"
            value={couriersMapStatusses?.filter((method) =>
              options?.statuses?.includes(method?.value[0])
            )}
            getOptionLabel={(option) => `${t(`${option.translationKey}`)}`}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            menuPortalTarget={document.getElementById("root")}
          />
        </div>
        <div className="my-[2rem]">
          <BooleanWithLabel
            checked={options.show_orders_assigned_to_courier}
            onChange={(e) =>
              setOptions((values) => ({
                ...values,
                show_orders_assigned_to_courier: e.target.checked,
              }))
            }
          >
            {t("show_orders_with_courier")}
          </BooleanWithLabel>
        </div>
        <div className="my-[2rem]">
          <BooleanWithLabel
            checked={options.pin_code_check}
            onChange={(e) =>
              setOptions((values) => ({
                ...values,
                pin_code_check: e.target.checked,
              }))
            }
          >
            {t("pincodeControl")}
          </BooleanWithLabel>
        </div>
        <div className="my-[2rem]">
          <BooleanWithLabel
            checked={options.merge_formulas}
            onChange={(e) =>
              setOptions((values) => ({
                ...values,
                merge_formulas: e.target.checked,
              }))
            }
          >
            {t("mergeBranches")}
          </BooleanWithLabel>
        </div>
        <div className="my-[2rem]">
          <BooleanWithLabel
            checked={options.couriers_can_assign_orders_to_themselves}
            onChange={(e) =>
              setOptions((values) => ({
                ...values,
                couriers_can_assign_orders_to_themselves: e.target.checked,
              }))
            }
          >
            {t("couriersCanAssignOrdersToThemselves")}
          </BooleanWithLabel>
        </div>

        <Button isPending={save.isPending} onClick={onSave}>
          {t("save")}
        </Button>
      </div>
    </Modal>
  );
};
export default MapOrdersSettingsModal;
